<template>
  <div>
    <div class="d-flex align-center">
      <v-row>
        <v-col cols="12" sm="4">
          <div class="d-flex">
            <Range style="width: 100%" />
            <v-btn class="info mt-1" small @click="getPlayers()">
              <v-icon small left>mdi-filter</v-icon>{{ $t("btnFilter") }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="4" offset-sm="4">
          <div
            class="d-flex align-center"
            :class="$vuetify.breakpoint.xs ? 'justify-center' : 'justify-end'"
            style="height: 100%"
          >
            <span class="text-body-1 font-weight-regular text-end">
              {{ $t("from") }}
              {{ rangeDate.start_date && new Date(rangeDate.start_date.replace(" ", "T")).toLocaleDateString() }}
              {{ $t("until") }}
              {{ rangeDate.final_date && new Date(rangeDate.final_date.replace(" ", "T")).toLocaleDateString() }}
            </span>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider class="my-2 mb-4" />

    <!-- Visão geral -->
    <div class="d-flex flex-column mb-10">
      <div class="mt-10 mb-6">
        <span class="text-h4">{{ $t("overview") }}</span>
        <p>{{ $t("homeGraphicTitle.overviewDescription") }}</p>
      </div>
      <v-row>
        <!-- Cards de apostas, prêmios, ticket médio e ggr -->
        <v-col cols="12">
          <v-row>
            <v-col
              v-for="(data, index) in generalData"
              :key="index"
              :cols="12"
              md="4"
            >
              <v-card
                :color="
                  index != 'ggr'
                    ? data.color
                    : data.value >= 0
                    ? data.color
                    : data.colorNegative
                "
                :style="{ color: index == 'prize' ? 'black' : 'white' }"
              >
                <div
                  class="d-flex justify-space-between align-center pa-4"
                  style="height: 100%"
                >
                  <div>
                    <div>
                      <div style="font-size: 24px">
                        {{ getPortugueseMoney(data.value) }}
                      </div>
                      <span v-if="index === 'bet'">
                        {{ data.qtdBetAllPlayer }}
                      </span>
                      <span v-if="index === 'prize'">
                        {{ data.qtdPrizeAllPlayer }}
                      </span>
                      <span>{{ data.name }}</span>
                    </div>
                  </div>
                  <span
                    v-if="index !== 'bet'"
                    class="text-h5"
                    :style="{ color: index == 'prize' ? 'black' : 'white' }"
                  >
                    {{ data.percentage }}%
                  </span>
                </div>

                <v-divider />

                <div class="px-4 py-2">
                  {{
                    $tc(
                      "homeGraphicTitle.averageDailyDescription",
                      index == "bet"
                        ? 0
                        : index == "prize"
                        ? 1
                        : index == "ggr"
                        ? 2
                        : 0,
                      {
                        average: getPortugueseMoney(data.ticket),
                      }
                    )
                  }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!-- Gráfico de barra Apostas por Estado -->
        <v-col cols="12">
          <v-card class="mt-3">
            <v-row class="px-4">
              <v-col cols="12" sm="4" md="3">
                <span class="text-h6 font-weight-regular">
                  {{ $t("dataByRegion") }}
                </span>
              </v-col>
              <v-col cols="12" sm="4" md="3" offset-sm="4" offset-md="6">
                <v-select
                  v-model="selectedGeneralTypeChartBarData"
                  :items="listTypeChartBarData"
                  item-text="name"
                  item-value="id"
                  :label="$t('filterBy')"
                  :no-data-text="$t('noDataOptions')"
                  outlined
                  dense
                  hide-details
                  @change="buildChartBarData()"
                  style="z-index: 1"
                >
                  <template v-slot:item="{ item }">
                    <v-icon class="ml-1" :color="item.color">
                      mdi-square
                    </v-icon>
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div class="px-4">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <NewBarChart
                        :data="chartBarData.dataSets"
                        :labels="chartBarData.labels"
                        :modifyOptions="chartBarData.optionsGeneral"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div
                        class="d-flex justify-center align-center"
                        style="height: 100%"
                      >
                        <MapGoogleChart
                          idElement="div_googleChartMap"
                          :labelTooltip="labelTooltipChartMap"
                          :data="chartMapData"
                          :colors="colorsMapGoogleChart"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Visão Apostas Esportivas -->
    <div class="d-flex flex-column mb-10">
      <!-- Header -->
      <div class="mt-10 mb-6">
        <v-row>
          <v-col cols="12" sm="8">
            <span class="text-h4">
              {{ $t("homeGraphicTitle.sports") }}
            </span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="playerSelectedSports"
              :label="$t('players')"
              :items="listPlayersSports"
              prepend-inner-icon="mdi-chart-line"
              item-text="user_name"
              item-value="user_id"
              dense
              outlined
              hide-details
              :no-data-text="$t('noDataTablePlayers')"
              @change="
                buildChartLineData(playerSelectedSports, 'sports'),
                  buildCardsData(playerSelectedSports, 'sports')
              "
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <!-- Gráfico em linha dos jogadores ofensivos em sports -->
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col
              v-for="(data, index) in generalDataSports"
              :key="index"
              :cols="12"
              md="4"
            >
              <v-card
                :color="
                  index != 'ggr'
                    ? data.color
                    : data.value >= 0
                    ? data.color
                    : data.colorNegative
                "
                :style="{ color: index == 'prize' ? 'black' : 'white' }"
              >
                <div
                  class="d-flex justify-space-between align-center pa-4"
                  style="height: 100%"
                >
                  <div>
                    <div style="font-size: 24px">
                      {{ getPortugueseMoney(data.value) }}
                    </div>
                    <span v-if="index === 'bet'">
                      {{
                        playerSelectedSports === "todos"
                          ? data.qtdBetAllPlayer
                          : getDataPlayerSelected("sports").qty_sport_bet
                      }}
                    </span>
                    <span v-if="index === 'prize'">
                      {{
                        playerSelectedSports === "todos"
                          ? data.qtdPrizeAllPlayer
                          : getDataPlayerSelected("sports").qty_sport_prize
                      }}
                    </span>
                    <span>{{ data.name }}</span>
                  </div>
                  <span
                    v-if="index !== 'bet'"
                    class="text-h5"
                    :style="{ color: index == 'prize' ? 'black' : 'white' }"
                  >
                    {{ data.percentage }}%
                  </span>
                </div>

                <v-divider />

                <div class="px-4 py-2">
                  {{
                    $tc(
                      "homeGraphicTitle.averageDailyDescription",
                      index == "bet"
                        ? 0
                        : index == "prize"
                        ? 1
                        : index == "ggr"
                        ? 2
                        : 0,
                      {
                        average:
                          playerSelectedSports === "todos"
                            ? getPortugueseMoney(data.ticket)
                            : getPortugueseMoney(
                                getDataPlayerSelected("sports").ticket[index]
                              ),
                      }
                    )
                  }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-card>
            <div class="d-flex">
              <div>
                <v-card-title class="subtitle-2 pb-0">
                  {{ $t("homeGraphicTitle.sports") }}
                </v-card-title>
                <v-card-text class="pb-0">
                  {{ $t("from") }}
                  {{ rangeDate.start_date && new Date(rangeDate.start_date.replace(" ", "T")).toLocaleDateString() }}
                  {{ $t("until") }}
                  {{ rangeDate.final_date && new Date(rangeDate.final_date.replace(" ", "T")).toLocaleDateString() }}
                </v-card-text>
              </div>
            </div>
            <div class="pa-6 pt-0">
              <LineChart
                :data="chartLineData.dataSets"
                :dataItems="chartLineData.sports.data"
                :labels="chartLineData.labels"
                :modifyOptions="chartLineData.optionsSports"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Tabelas dos jogadores ofensivos e não ofensivos em sports -->
      <v-row>
        <v-col cols="12" sm="6">
          <v-card class="py-4 px-0">
            <v-row>
              <v-col cols="12" sm="7">
                <v-card-title class="text-h6 font-weight-regular py-0 pl-4">
                  <v-icon></v-icon>
                  {{ $t("homeGraphicTitle.noOffensivePlayers") }}
                </v-card-title>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  class="mx-4"
                  v-model="searchNoOffensiveSportsPlayers"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-text>
              <v-data-table
                :headers="headersPlayers()"
                :items="noOffensiveSportsPlayers"
                :search="searchNoOffensiveSportsPlayers"
                mobile-breakpoint="-100"
                :items-per-page="10"
                hide-default-footer
                :footer-props="{
                  'items-per-page-text': $t('rowsPerPage'),
                }"
              >
                <template v-slot:no-data>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template v-slot:no-results>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template
                  v-for="(value, index) in valueColors"
                  v-slot:[`item.${value}`]="{ item }"
                >
                  <div
                    :key="index"
                    :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''"
                  >
                    <span :style="{ color: getColor(item[value], value) }">
                      {{ getPortugueseMoney(item[value], true) }}
                    </span>
                  </div>
                </template>
                <template v-slot:item.ranking="{ item }">
                  <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''">
                    {{ item.ranking }}
                  </div>
                </template>
                <template v-slot:item.user_name="{ item }">
                  <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''">
                    {{ item.user_name }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="py-4 px-0">
            <v-row>
              <v-col cols="12" sm="7">
                <v-card-title class="text-h6 font-weight-regular py-0 pl-4">
                  <v-icon></v-icon>
                  {{ $t("homeGraphicTitle.offensivePlayers") }}
                </v-card-title>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  class="mx-4"
                  v-model="searchOffensiveSportsPlayers"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-text>
              <v-data-table
                :headers="headersPlayers()"
                :items="offensiveSportsPlayers"
                :search="searchOffensiveSportsPlayers"
                mobile-breakpoint="-100"
                :items-per-page="10"
                hide-default-footer
                :footer-props="{
                  'items-per-page-text': $t('rowsPerPage'),
                }"
              >
                <template v-slot:no-data>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template v-slot:no-results>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template
                  v-for="(value, index) in valueColors"
                  v-slot:[`item.${value}`]="{ item }"
                >
                  <div
                    :key="index"
                    :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''"
                  >
                    <span :style="{ color: getColor(item[value], value) }">
                      {{ getPortugueseMoney(item[value], true) }}
                    </span>
                  </div>
                </template>
                <template v-slot:item.user_name="{ item }">
                  <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''">
                    {{ item.user_name }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Visão Apostas em Cassino -->
    <div class="d-flex flex-column mb-10">
      <!-- Header -->
      <div class="mt-10 mb-6">
        <v-row>
          <v-col cols="12" sm="8">
            <span class="text-h4">
              {{ $t("homeGraphicTitle.casino") }}
            </span>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="playerSelectedCasino"
              :label="$t('players')"
              :items="listPlayersCasino"
              prepend-inner-icon="mdi-chart-line"
              item-text="user_name"
              item-value="user_id"
              dense
              outlined
              hide-details
              :no-data-text="$t('noDataTablePlayers')"
              @change="
                buildChartLineData(playerSelectedCasino, 'casino'),
                  buildCardsData(playerSelectedCasino, 'casino')
              "
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <!-- Gráfico em linha dos jogadores ofensivos em casino -->
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col
              v-for="(data, index) in generalDataCasino"
              :key="index"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
              md="4"
            >
              <v-card
                :color="
                  index != 'ggr'
                    ? data.color
                    : data.value >= 0
                    ? data.color
                    : data.colorNegative
                "
                :style="{ color: index == 'prize' ? 'black' : 'white' }"
              >
                <div
                  class="d-flex justify-space-between align-center pa-4"
                  style="height: 100%"
                >
                  <div>
                    <div style="font-size: 24px">
                      {{ getPortugueseMoney(data.value) }}
                    </div>
                    <span v-if="index === 'bet'">
                      {{
                        playerSelectedCasino === "todos"
                          ? data.qtdBetAllPlayer
                          : getDataPlayerSelected("casino").qty_casino_bet
                      }}
                    </span>
                    <span v-if="index === 'prize'">
                      {{
                        playerSelectedCasino === "todos"
                          ? data.qtdPrizeAllPlayer
                          : getDataPlayerSelected("casino").qty_casino_prize
                      }}
                    </span>
                    <span>{{ data.name }}</span>
                  </div>
                  <span
                    v-if="index !== 'bet'"
                    class="text-h5"
                    :style="{ color: index == 'prize' ? 'black' : 'white' }"
                  >
                    {{ data.percentage }}%
                  </span>
                </div>

                <v-divider />

                <div class="px-4 py-2">
                  {{
                    $tc(
                      "homeGraphicTitle.averageDailyDescription",
                      index == "bet"
                        ? 0
                        : index == "prize"
                        ? 1
                        : index == "ggr"
                        ? 2
                        : 0,
                      {
                        average:
                          playerSelectedCasino === "todos"
                            ? getPortugueseMoney(data.ticket)
                            : getPortugueseMoney(
                                getDataPlayerSelected("casino").ticket[index]
                              ),
                      }
                    )
                  }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-card>
            <div class="d-flex">
              <div>
                <v-card-title class="subtitle-2 pb-0">
                  {{ $t("homeGraphicTitle.casino") }}
                </v-card-title>
                <v-card-text class="pb-0">
                  {{ $t("from") }}
                  {{rangeDate.start_date && new Date(rangeDate.start_date.replace(" ", "T")).toLocaleDateString() }}
                  {{ $t("until") }}
                  {{ rangeDate.final_date && new Date(rangeDate.final_date.replace(" ", "T")).toLocaleDateString() }}
                </v-card-text>
              </div>
            </div>
            <div class="pa-6 pt-0">
              <LineChart
                :data="chartLineData.dataSets"
                :dataItems="chartLineData.casino.data"
                :labels="chartLineData.labels"
                :modifyOptions="chartLineData.optionsCasino"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Tabelas dos jogadores ofensivos e não ofensivos em casino -->
      <v-row>
        <v-col cols="12" sm="6">
          <v-card class="py-4 px-0">
            <v-row>
              <v-col cols="12" sm="7">
                <v-card-title class="text-h6 font-weight-regular py-0 pl-4">
                  <v-icon></v-icon>
                  {{ this.$t("homeGraphicTitle.noOffensivePlayers") }}
                </v-card-title>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  class="mx-4"
                  v-model="searchNoOffensiveCasinoPlayers"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-text>
              <v-data-table
                :headers="headersPlayers(true)"
                :items="noOffensiveCasinoPlayers"
                :search="searchNoOffensiveCasinoPlayers"
                mobile-breakpoint="-100"
                :items-per-page="10"
                hide-default-footer
                :footer-props="{
                  'items-per-page-text': $t('rowsPerPage'),
                }"
              >
                <template v-slot:no-data>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template v-slot:no-results>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template
                  v-for="(value, index) in valueColors"
                  v-slot:[`item.${value}`]="{ item }"
                >
                  <div
                    :key="index"
                    :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''"
                  >
                    <span :style="{ color: getColor(item[value], value) }">
                      {{ getPortugueseMoney(item[value], true) }}
                    </span>
                  </div>
                </template>
                <template v-slot:item.user_name="{ item }">
                  <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''">
                    {{ item.user_name }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="py-4 px-0">
            <v-row>
              <v-col cols="12" sm="7">
                <v-card-title class="text-h6 font-weight-regular py-0 pl-4">
                  <v-icon></v-icon>
                  {{ this.$t("homeGraphicTitle.offensivePlayers") }}
                </v-card-title>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  class="mx-4"
                  v-model="searchOffensiveCasinoPlayers"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-text>
              <v-data-table
                :headers="headersPlayers(true)"
                :items="offensiveCasinoPlayers"
                :search="searchOffensiveCasinoPlayers"
                mobile-breakpoint="-100"
                :items-per-page="10"
                hide-default-footer
                :footer-props="{
                  'items-per-page-text': $t('rowsPerPage'),
                }"
              >
                <template v-slot:no-data>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template v-slot:no-results>
                  {{ $t("noDataTablePlayers") }}
                </template>
                <template
                  v-for="(value, index) in valueColors"
                  v-slot:[`item.${value}`]="{ item }"
                >
                  <div
                    :key="index"
                    :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''"
                  >
                    <span :style="{ color: getColor(item[value], value) }">
                      {{ getPortugueseMoney(item[value], true) }}
                    </span>
                  </div>
                </template>
                <template v-slot:item.user_name="{ item }">
                  <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : ''">
                    {{ item.user_name }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import Range from "@/components/common/filters/Range";
import LineChart from "@/components/Charts/LineChart";
import NewBarChart from "@/components/Charts/NewBarChart";
import MapGoogleChart from "../../../../components/Charts/MapGoogleChart.vue";
import { UFlabelDDD } from "@/util/ddd.js";

export default {
  name: "administrator-dashboard-home",
  components: {
    Range,
    LineChart,
    NewBarChart,
    MapGoogleChart,
  },
  data: () => ({
    // Visão geral
    generalData: {
      bet: {
        name: "Apostas",
        color: "rgb(21, 101, 192)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdBetAllPlayer: 0,
      },
      prize: {
        name: "Prêmios",
        color: "rgb(242, 167, 36)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdPrizeAllPlayer: 0,
      },
      ggr: {
        name: "GGR (projetado)",
        color: "rgb(71, 126, 50)",
        colorNegative: "#D32F2F",
        value: 0,
        percentage: 0,
        ticket: 0,
      },
    },
    generalDataSports: {
      bet: {
        name: "Apostas",
        color: "rgb(21, 101, 192)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdBetAllPlayer: 0,
      },
      prize: {
        name: "Prêmios",
        color: "rgb(242, 167, 36)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdPrizeAllPlayer: 0,
      },
      ggr: {
        name: "GGR (projetado)",
        color: "rgb(71, 126, 50)",
        colorNegative: "#D32F2F",
        value: 0,
        percentage: 0,
        ticket: 0,
      },
    },
    generalDataCasino: {
      bet: {
        name: "Apostas",
        color: "rgb(21, 101, 192)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdBetAllPlayer: 0,
      },
      prize: {
        name: "Prêmios",
        color: "rgb(242, 167, 36)",
        value: 0,
        percentage: 0,
        ticket: 0,
        qtdPrizeAllPlayer: 0,
      },
      ggr: {
        name: "GGR (projetado)",
        color: "rgb(71, 126, 50)",
        colorNegative: "#D32F2F",
        value: 0,
        percentage: 0,
        ticket: 0,
      },
    },
    // Todos os jogadores
    players: null,
    // Dados do gráfico em linha dos jogadores ofensivos
    chartLineData: {
      dataSets: [
        {
          id: "bet",
          labelTranslate: "bets",
          backgroundColorGradient: [
            "rgb(21, 101, 192)",
            "rgba(21, 101, 192, 0)",
          ],
          borderWidth: 2,
          borderColor: "rgba(21, 101, 192, .8)",
          pointBackgroundColor: "rgb(21, 101, 192)",
          pointBorderColor: "rgb(21, 101, 192)",
        },
        {
          id: "prize",
          labelTranslate: "prizeValue",
          backgroundColorGradient: [
            "rgb(242, 167, 36)",
            "rgba(242, 167, 36, 0)",
          ],
          borderColor: "rgb(242, 167, 36)",
          pointBackgroundColor: "rgb(242, 167, 36)",
          borderWidth: 2,
          pointBorderColor: "rgb(242, 167, 36)",
        },
        {
          id: "ggr",
          label: "GGR",
          borderColor: "rgb(71, 126, 50)",
          pointBackgroundColorVariant: ["rgb(71, 126, 50)", "#A11919"],
          borderWidth: 2,
          pointBorderColorVariant: ["rgb(71, 126, 50)", "#A11919"],
          negativeLinesColor: ["rgb(86,188,77)", "rgb(229,66,66)"],
        },
      ],
      sports: {
        data: {
          bet: [],
          prize: [],
          ggr: [],
        },
      },
      casino: {
        data: {
          bet: [],
          prize: [],
          ggr: [],
        },
      },
      labels: [],
      optionsSports: {
        verticalLabel: "R$",
        horizontalLabel: "",
      },
      optionsCasino: {
        verticalLabel: "R$",
        horizontalLabel: "",
      },
    },
    // Dados do gráfico de barra dos jogadores
    chartBarData: {
      dataSets: [
        {
          label: "Apostas",
          data: [],
          fill: false,
          maxBarThickness: 30,
          backgroundColor: "rgba(21, 101, 192, 1)",
        },
      ],
      labels: [],
      optionsGeneral: {
        horizontalLabel: "",
        height: "500px",
      },
    },
    // Dados do gráfico de mapa dos jogadores
    chartMapData: [],
    labelTooltipChartMap: "Apostas",
    stateColorChartMap: "",
    // Items do dataTable
    valueColors: [
      "sport_bet",
      "sport_prize",
      "sport_ggr",
      "casino_bet",
      "casino_prize",
      "casino_ggr",
    ],
    allDatesPlayers: [],
    // GGR positivo - banca perde
    offensiveSportsPlayers: [],
    searchOffensiveSportsPlayers: "",
    offensiveCasinoPlayers: [],
    searchOffensiveCasinoPlayers: "",
    // GGR negativo - banca ganha
    noOffensiveSportsPlayers: [],
    searchNoOffensiveSportsPlayers: "",
    noOffensiveCasinoPlayers: [],
    searchNoOffensiveCasinoPlayers: "",
    // Filtro de Jogadores
    playerSelectedSports: "todos",
    playerSelectedCasino: "todos",
    listPlayersSports: [],
    listPlayersCasino: [],
    // Filtro bar chart general
    selectedGeneralTypeChartBarData: "bet",
    listTypeChartBarData: [],
  }),
  async mounted() {
    this.$store.commit("SetRangeDate", {});

    await this.$request.get("administrator/dashboard/home");

    this.generalData.bet.name = this.$t("bets");
    this.generalData.prize.name = this.$t("prizeValue");
    this.generalData.ggr.name = this.$t("valueGGRProjected");
    this.generalDataSports.bet.name = this.$t("bets");
    this.generalDataSports.prize.name = this.$t("prizeValue");
    this.generalDataSports.ggr.name = this.$t("valueGGRProjected");
    this.generalDataCasino.bet.name = this.$t("bets");
    this.generalDataCasino.prize.name = this.$t("prizeValue");
    this.generalDataCasino.ggr.name = this.$t("valueGGRProjected");

    this.getPlayers();
  },
  computed: {
    rangeDate() {
      const { data_inicio, data_final } = this.$store.state.range.date;
      return {
        start_date: this.$date.format(data_inicio, "YYYY-MM-DD HR:MM:SS"),
        final_date: this.$date.format(data_final, "YYYY-MM-DD HR:MM:SS"),
      };
    },
    progress() {
      return this.$store.state.feedbackProgress;
    },
    colorsMapGoogleChart() {
      const isGGRSelected = this.selectedGeneralTypeChartBarData === "ggr";

      return (
        this.stateColorChartMap && [
          ...(isGGRSelected
            ? ["rgb(229,66,66)", "#5CA240", "#519039", this.stateColorChartMap]
            : ["#acb2b9"]),
          this.stateColorChartMap,
        ]
      );
    },
    formatLengthDatesPlayers() {
      // Ao filtrar range de data por últimos 7 dias ou últimos 15 dias é
      // incluído o dia atual fazendo com que o cálculo baseado no qtd de dias
      // fique inconsistente
      if (this.allDatesPlayers.length === 8) {
        return 7;
      } else if (this.allDatesPlayers.length === 16) {
        return 15;
      }
      return this.allDatesPlayers.length;
    },
  },
  methods: {
    getPlayers() {
      this.$store.commit("setFeedbackProgress", true);
      this.playerSelectedSports = "todos";
      this.playerSelectedCasino = "todos";

      this.$axios
        .post(
          "administrator/players/playersGgr",
          this.$formdata(this.rangeDate)
        )
        .then(async (res) => {
          this.players = res.data;

          this.allDatesPlayers = this.$date.get.daysBetweenTwoDates(
            this.$date.format(this.rangeDate.start_date, "YYYY-MM-DD"),
            this.$date.format(this.rangeDate.final_date, "YYYY-MM-DD")
          );

          this.chartLineData.labels = this.allDatesPlayers.map((date) =>
            this.$date.format(date, "DD/MM")
          );

          // Formatar jogadores ofensivos e não ofensivos (Tabelas)
          this.formatOffensivePlayersData();
          // Estruturar os dados do gráfico em Linha
          this.buildChartLineData();
          // Estruturar os dados dos cards
          this.buildCardsData();
          // Estruturar os dados dos gráfico em Barra
          this.buildChartBarData();
        })
        .catch(() => {})
        .finally(() => {});
    },
    formatOffensivePlayersData() {
      // RESET VALUES
      // Objeto dos jogadores - Estrutura { "user_id": {...player}, ... }
      // Ex. {"1038998": {...playerData}, ... }
      let hashTableUser = {};
      this.listPlayersSports = [];
      this.listPlayersCasino = [];
      this.searchOffensiveSportsPlayers = "";
      this.searchNoOffensiveSportsPlayers = "";
      this.searchOffensiveCasinoPlayers = "";
      this.searchNoOffensiveCasinoPlayers = "";
      let sport_qtdBetAllPlayer = 0;
      let sport_qtdPrizeAllPlayer = 0;
      let casino_qtdBetAllPlayer = 0;
      let casino_qtdPrizeAllPlayer = 0;

      // Inserir um player ao obj de players
      function insertPlayer(player) {
        const key = player.user_id.toString();
        hashTableUser[key] = player;
      }

      // Buscar um player no obj de players pelo user_id (chave)
      function searchPlayer(playerId) {
        const key = playerId.toString();
        return hashTableUser[key] || -1;
      }

      function updatePlayer(playerId, newData) {
        const key = playerId.toString();
        const existingUser = hashTableUser[key];

        Object.assign(existingUser, newData);
      }

      this.players.forEach((player) => {
        const index = searchPlayer(player.user_id);

        if (index == -1) {
          // Se não existir, adiciona o jogador
          insertPlayer({
            ...player,
            qty_sport_bet: +player.qty_sport_bet,
            qty_sport_prize: +player.qty_sport_prize,
            qty_casino_bet: +player.qty_casino_bet,
            qty_casino_prize: +player.qty_casino_prize,
          })
        } else {
          // Se existir adiciona os dados no jogador que está no obj dos jogadores formatados
          const existPlayer = hashTableUser[player.user_id];

          updatePlayer(player.user_id, {
            ...existPlayer,
            casino_bet: (+player.casino_bet + +existPlayer.casino_bet).toFixed(2),
            casino_prize: (+player.casino_prize + +existPlayer.casino_prize).toFixed(2),
            casino_ggr: (+player.casino_ggr + +existPlayer.casino_ggr).toFixed(2),
            sport_bet: (+player.sport_bet + +existPlayer.sport_bet).toFixed(2),
            sport_prize: (+player.sport_prize + +existPlayer.sport_prize).toFixed(2),
            sport_ggr: (+player.sport_ggr + +existPlayer.sport_ggr).toFixed(2),
            // Qtd de apostas por usuário
            qty_sport_bet: +player.qty_sport_bet + existPlayer.qty_sport_bet,
            qty_sport_prize: +player.qty_sport_prize + existPlayer.qty_sport_prize,
            qty_casino_bet: +player.qty_casino_bet + existPlayer.qty_casino_bet,
            qty_casino_prize: +player.qty_casino_prize + existPlayer.qty_casino_prize,
          });
        }

        // Qtd de apostas de todos os usuários
        sport_qtdBetAllPlayer += +player.qty_sport_bet;
        sport_qtdPrizeAllPlayer += +player.qty_sport_prize;
        casino_qtdBetAllPlayer += +player.qty_casino_bet;
        casino_qtdPrizeAllPlayer += +player.qty_casino_prize;
      });

      // Popular QTD nos cards
      this.generalData.bet.qtdBetAllPlayer =
        sport_qtdBetAllPlayer + casino_qtdBetAllPlayer;
      this.generalData.prize.qtdPrizeAllPlayer =
        sport_qtdPrizeAllPlayer + casino_qtdPrizeAllPlayer;

      this.generalDataSports.bet.qtdBetAllPlayer = sport_qtdBetAllPlayer;
      this.generalDataSports.prize.qtdPrizeAllPlayer = sport_qtdPrizeAllPlayer;

      this.generalDataCasino.bet.qtdBetAllPlayer = casino_qtdBetAllPlayer;
      this.generalDataCasino.prize.qtdPrizeAllPlayer = casino_qtdPrizeAllPlayer;

      // Filtrar jogadores ofensivos e não ofensivos de Sports e Casino
      this.formatPlayersFiltered(hashTableUser);
    },
    buildChartLineData(playerId, typeData) {
      // RESET VALUES
      if (playerId && typeData === "sports") {
        this.chartLineData.sports.data.bet = [];
        this.chartLineData.sports.data.prize = [];
        this.chartLineData.sports.data.ggr = [];
      } else if (playerId && typeData === "casino") {
        this.chartLineData.casino.data.bet = [];
        this.chartLineData.casino.data.prize = [];
        this.chartLineData.casino.data.ggr = [];
      } else if (this.chartLineData.sports.data.bet.length > 0) {
        this.chartLineData.sports.data.bet = [];
        this.chartLineData.sports.data.prize = [];
        this.chartLineData.sports.data.ggr = [];

        this.chartLineData.casino.data.bet = [];
        this.chartLineData.casino.data.prize = [];
        this.chartLineData.casino.data.ggr = [];
      }

      this.allDatesPlayers.forEach((date) => {
        let betSports = 0;
        let prizeSports = 0;
        let ggrSports = 0;
        let betCasino = 0;
        let prizeCasino = 0;
        let ggrCasino = 0;

        this.players.forEach((player) => {
          if (date === player.date) {
            if (playerId === player.user_id) {
              if (typeData === "sports") {
                betSports = betSports + +player.sport_bet;
                prizeSports = prizeSports + +player.sport_prize;
                ggrSports = ggrSports + +player.sport_ggr;
              } else if (typeData === "casino") {
                betCasino = betCasino + +player.casino_bet;
                prizeCasino = prizeCasino + +player.casino_prize;
                ggrCasino = ggrCasino + +player.casino_ggr;
              }
            } else if (!playerId || playerId === "todos") {
              betSports = betSports + +player.sport_bet;
              prizeSports = prizeSports + +player.sport_prize;
              ggrSports = ggrSports + +player.sport_ggr;

              betCasino = betCasino + +player.casino_bet;
              prizeCasino = prizeCasino + +player.casino_prize;
              ggrCasino = ggrCasino + +player.casino_ggr;
            }
          }
        });

        if (playerId) {
          if (typeData === "sports") {
            this.chartLineData.sports.data.bet.push(betSports.toFixed(2));
            this.chartLineData.sports.data.prize.push(prizeSports.toFixed(2));
            this.chartLineData.sports.data.ggr.push(ggrSports.toFixed(2));
          } else if (typeData === "casino") {
            this.chartLineData.casino.data.bet.push(betCasino.toFixed(2));
            this.chartLineData.casino.data.prize.push(prizeCasino.toFixed(2));
            this.chartLineData.casino.data.ggr.push(ggrCasino.toFixed(2));
          }
        } else if (!playerId || playerId === "todos") {
          this.chartLineData.sports.data.bet.push(betSports.toFixed(2));
          this.chartLineData.sports.data.prize.push(prizeSports.toFixed(2));
          this.chartLineData.sports.data.ggr.push(ggrSports.toFixed(2));

          this.chartLineData.casino.data.bet.push(betCasino.toFixed(2));
          this.chartLineData.casino.data.prize.push(prizeCasino.toFixed(2));
          this.chartLineData.casino.data.ggr.push(ggrCasino.toFixed(2));
        }
      });

      this.chartLineData.optionsSports = {
        ...this.chartLineData.optionsSports,
        horizontalLabel: this.$t("homeChartLineOptions.sports.horizontalLabel"),
      };

      this.chartLineData.optionsCasino = {
        ...this.chartLineData.optionsCasino,
        horizontalLabel: this.$t("homeChartLineOptions.casino.horizontalLabel"),
      };

      // Atualizar a prop data do componente e forçar o watch para fazer
      // modificações no Data dentro do componente
      this.chartLineData = JSON.parse(JSON.stringify(this.chartLineData));
    },
    // Soma de Bets, Prizes e GGR
    // general(Bet/Prize/GGR) - Sports + Casino
    // generalSports(Bet/Prize/GGR) - Sports
    // generalCasino(Bet/Prize/GGR) - Casino
    buildCardsData(playerId, typeData) {
      // RESET VALUES
      if (playerId && typeData === "sports") {
        this.generalDataSports.bet = {
          ...this.generalDataSports.bet,
          value: 0,
          percentage: 0,
        };
        this.generalDataSports.prize = {
          ...this.generalDataSports.prize,
          value: 0,
          percentage: 0,
        };
        this.generalDataSports.ggr = {
          ...this.generalDataSports.ggr,
          value: 0,
          percentage: 0,
        };
      } else if (playerId && typeData === "casino") {
        this.generalDataCasino.bet = {
          ...this.generalDataCasino.bet,
          value: 0,
          percentage: 0,
        };
        this.generalDataCasino.prize = {
          ...this.generalDataCasino.prize,
          value: 0,
          percentage: 0,
        };
        this.generalDataCasino.ggr = {
          ...this.generalDataCasino.ggr,
          value: 0,
          percentage: 0,
        };
      } else if (!playerId) {
        this.generalData.bet = {
          ...this.generalData.bet,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalData.prize = {
          ...this.generalData.prize,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalData.ggr = {
          ...this.generalData.ggr,
          value: 0,
          percentage: 0,
          ticket: 0,
        };

        this.generalDataSports.bet = {
          ...this.generalDataSports.bet,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalDataSports.prize = {
          ...this.generalDataSports.prize,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalDataSports.ggr = {
          ...this.generalDataSports.ggr,
          value: 0,
          percentage: 0,
          ticket: 0,
        };

        this.generalDataCasino.bet = {
          ...this.generalDataCasino.bet,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalDataCasino.prize = {
          ...this.generalDataCasino.prize,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
        this.generalDataCasino.ggr = {
          ...this.generalDataCasino.ggr,
          value: 0,
          percentage: 0,
          ticket: 0,
        };
      }

      // Em cada data iterar em cada jogador que tiver feito alguma aposta nessa
      // data somar as Bets/Prizes/GGR
      this.allDatesPlayers.forEach((date) => {
        let generalBet = 0;
        let generalPrize = 0;
        let generalGGR = 0;
        let generalSportsBet = 0;
        let generalSportsPrize = 0;
        let generalSportsGGR = 0;
        let generalCasinoBet = 0;
        let generalCasinoPrize = 0;
        let generalCasinoGGR = 0;

        this.players.forEach((player) => {
          if (date === player.date) {
            if (playerId === player.user_id || playerId === "todos") {
              if (
                (playerId === "todos" && typeData === "sports") ||
                typeData === "sports"
              ) {
                generalSportsBet = generalSportsBet + +player.sport_bet;
                generalSportsPrize = generalSportsPrize + +player.sport_prize;
                generalSportsGGR = generalSportsGGR + +player.sport_ggr;
              } else if (
                (playerId === "todos" && typeData === "casino") ||
                typeData === "casino"
              ) {
                generalCasinoBet = generalCasinoBet + +player.casino_bet;
                generalCasinoPrize = generalCasinoPrize + +player.casino_prize;
                generalCasinoGGR = generalCasinoGGR + +player.casino_ggr;
              }
            } else if (!playerId) {
              generalBet = generalBet + +player.sport_bet + +player.casino_bet;
              generalPrize =
                generalPrize + +player.sport_prize + +player.casino_prize;
              generalGGR = generalGGR + +player.sport_ggr + +player.casino_ggr;

              generalSportsBet = generalSportsBet + +player.sport_bet;
              generalSportsPrize = generalSportsPrize + +player.sport_prize;
              generalSportsGGR = generalSportsGGR + +player.sport_ggr;

              generalCasinoBet = generalCasinoBet + +player.casino_bet;
              generalCasinoPrize = generalCasinoPrize + +player.casino_prize;
              generalCasinoGGR = generalCasinoGGR + +player.casino_ggr;
            }
          }
        });

        if (playerId) {
          if (
            (playerId === "todos" && typeData === "sports") ||
            typeData === "sports"
          ) {
            this.generalDataSports.bet.value =
              this.generalDataSports.bet.value + generalSportsBet;
            this.generalDataSports.prize.value =
              this.generalDataSports.prize.value + generalSportsPrize;
            this.generalDataSports.ggr.value =
              this.generalDataSports.ggr.value + generalSportsGGR;
          } else if (
            (playerId === "todos" && typeData === "casino") ||
            typeData === "casino"
          ) {
            this.generalDataCasino.bet.value =
              this.generalDataCasino.bet.value + generalCasinoBet;
            this.generalDataCasino.prize.value =
              this.generalDataCasino.prize.value + generalCasinoPrize;
            this.generalDataCasino.ggr.value =
              this.generalDataCasino.ggr.value + generalCasinoGGR;
          }
        } else if (!playerId) {
          this.generalData.bet.value = this.generalData.bet.value + generalBet;
          this.generalData.prize.value =
            this.generalData.prize.value + generalPrize;
          this.generalData.ggr.value = this.generalData.ggr.value + generalGGR;

          this.generalDataSports.bet.value =
            this.generalDataSports.bet.value + generalSportsBet;
          this.generalDataSports.prize.value =
            this.generalDataSports.prize.value + generalSportsPrize;
          this.generalDataSports.ggr.value =
            this.generalDataSports.ggr.value + generalSportsGGR;

          this.generalDataCasino.bet.value =
            this.generalDataCasino.bet.value + generalCasinoBet;
          this.generalDataCasino.prize.value =
            this.generalDataCasino.prize.value + generalCasinoPrize;
          this.generalDataCasino.ggr.value =
            this.generalDataCasino.ggr.value + generalCasinoGGR;
        }
      });

      // Adicionando dados como Percentagem (Bet/Prize/GGR) e
      // Ticket Médio (Bet/Prize/GGR) - Ticket médio seria a divisão do valor
      // (Bet/Prize/GGR) pela quantidade de dias
      // General Data
      this.generalData.bet.percentage = 100;
      this.generalData.bet.ticket = this.getAverageValuePlayer(
        this.generalData.bet.value,
        this.generalData.bet.qtdBetAllPlayer
      );
      this.generalData.prize.percentage = this.getPercentage(
        this.generalData.prize.value,
        this.generalData.bet.value
      );
      this.generalData.prize.ticket = this.getAverageValuePlayer(
        this.generalData.prize.value,
        this.generalData.prize.qtdPrizeAllPlayer
      );
      this.generalData.ggr.percentage = this.getPercentage(
        this.generalData.ggr.value,
        this.generalData.bet.value
      );
      this.generalData.ggr.ticket = this.getAverageValuePlayer(
        this.generalData.ggr.value,
        this.formatLengthDatesPlayers
      );

      // General Data Sports
      this.generalDataSports.bet.percentage = 100;
      this.generalDataSports.bet.ticket = this.getAverageValuePlayer(
        this.generalDataSports.bet.value,
        this.generalDataSports.bet.qtdBetAllPlayer
      );
      this.generalDataSports.prize.percentage = this.getPercentage(
        this.generalDataSports.prize.value,
        this.generalDataSports.bet.value
      );
      this.generalDataSports.prize.ticket = this.getAverageValuePlayer(
        this.generalDataSports.prize.value,
        this.generalDataSports.prize.qtdPrizeAllPlayer
      );
      this.generalDataSports.ggr.percentage = this.getPercentage(
        this.generalDataSports.ggr.value,
        this.generalDataSports.bet.value
      );
      this.generalDataSports.ggr.ticket = this.getAverageValuePlayer(
        this.generalDataSports.ggr.value,
        this.formatLengthDatesPlayers
      );

      // General Data Casino
      this.generalDataCasino.bet.percentage = 100;
      this.generalDataCasino.bet.ticket = this.getAverageValuePlayer(
        this.generalDataCasino.bet.value,
        this.generalDataCasino.bet.qtdBetAllPlayer
      );
      this.generalDataCasino.prize.percentage = this.getPercentage(
        this.generalDataCasino.prize.value,
        this.generalDataCasino.bet.value
      );
      this.generalDataCasino.prize.ticket = this.getAverageValuePlayer(
        this.generalDataCasino.prize.value,
        this.generalDataCasino.prize.qtdPrizeAllPlayer
      );
      this.generalDataCasino.ggr.percentage = this.getPercentage(
        this.generalDataCasino.ggr.value,
        this.generalDataCasino.bet.value
      );
      this.generalDataCasino.ggr.ticket = this.getAverageValuePlayer(
        this.generalDataCasino.ggr.value,
        this.formatLengthDatesPlayers
      );
    },
    buildChartBarData() {
      // Popular opções do select do gráfico em barra
      this.listTypeChartBarData.push(
        {
          name: this.$t("bets"),
          id: "bet",
          color: "rgb(21, 101, 192)",
        },
        {
          name: this.$t("prizeValue"),
          id: "prize",
          color: "rgb(242, 167, 36)",
        },
        {
          name: "GGR",
          id: "ggr",
          color: "rgb(71, 126, 50)",
        },
        {
          name: this.$t("qtdPlayers"),
          id: "qtdPlayers",
          color: "#00BCD4",
        }
      );

      let statesData = [];

      this.players.map((player) => {
        // Tratando número dos jogadores
        const dddPlayer = player.user_phone
          ? Number(
              player.user_phone
                .replace("(", "")
                .replace(")", "")
                .replace("+55", "")
                .slice(0, 2)
            )
          : false;

        // Procurar Dados do Estado pelo DDD do telefone
        const findStateByPhone = UFlabelDDD.find((uf) =>
          uf.ddd.includes(dddPlayer.toString())
        );

        // Se houver DDD e for incluso em algum Estado, atribuo o nome do Estado
        const findStateLabelByPhone =
          dddPlayer && findStateByPhone ? findStateByPhone.label : false;

        if (findStateLabelByPhone) {
          const existCurrentState = statesData.find(
            (state) => state.ufLabel === findStateLabelByPhone
          );

          if (existCurrentState) {
            statesData = statesData.map((state) => {
              if (state.ufLabel === existCurrentState.ufLabel) {
                return {
                  ...state,
                  qtdPlayers: state.qtdPlayers + 1,

                  generalBet:
                    state.generalBet + +player.sport_bet + +player.casino_bet,
                  generalPrize:
                    state.generalPrize +
                    +player.sport_prize +
                    +player.casino_prize,
                  generalGGR:
                    state.generalGGR + +player.sport_ggr + +player.casino_ggr,

                  betSports: state.betSports + +player.sport_bet,
                  prizeSports: state.prizeSports + +player.sport_prize,
                  ggrSports: state.ggrSports + +player.sport_ggr,

                  betCasino: state.betCasino + +player.casino_bet,
                  prizeCasino: state.prizeCasino + +player.casino_prize,
                  ggrCasino: state.ggrCasino + +player.casino_ggr,
                };
              }
              return state;
            });
          } else {
            statesData.push({
              ufLabel: findStateLabelByPhone,
              qtdPlayers: 1,

              generalBet: +player.sport_bet + +player.casino_bet,
              generalPrize: +player.sport_prize + +player.casino_prize,
              generalGGR: +player.sport_ggr + +player.casino_ggr,

              betSports: +player.sport_bet,
              prizeSports: +player.sport_prize,
              ggrSports: +player.sport_ggr,

              betCasino: +player.casino_bet,
              prizeCasino: +player.casino_prize,
              ggrCasino: +player.casino_ggr,
            });
          }
        }
      });

      this.chartBarData.labels = statesData.map((state) => state.ufLabel);

      this.chartBarData.optionsGeneral = {
        ...this.chartBarData.optionsGeneral,
        horizontalLabel: "R$",
      };

      if (this.selectedGeneralTypeChartBarData === "bet") {
        this.chartBarData.dataSets[0].data = statesData.map((state) =>
          state.generalBet.toFixed(2)
        );
        this.chartBarData.dataSets[0].label = this.$t("bets");
        this.chartBarData.dataSets[0].backgroundColor = "rgba(21, 101, 192)";

        // Popular dados do gráfico de Mapa dos jogadores
        this.labelTooltipChartMap = this.$t("bets");
        this.stateColorChartMap = "rgb(21, 101, 192)";
        this.chartMapData = statesData.map((state) => [
          state.ufLabel,
          state.generalBet,
        ]);
      } else if (this.selectedGeneralTypeChartBarData === "prize") {
        this.chartBarData.dataSets[0].data = statesData.map((state) =>
          state.generalPrize.toFixed(2)
        );
        this.chartBarData.dataSets[0].label = this.$t("prizeValue");
        this.chartBarData.dataSets[0].backgroundColor = "rgb(242, 167, 36)";

        // Popular dados do gráfico de Mapa dos jogadores
        this.labelTooltipChartMap = this.$t("prizeValue");
        this.stateColorChartMap = "rgb(242, 167, 36)";
        this.chartMapData = statesData.map((state) => [
          state.ufLabel,
          state.generalPrize,
        ]);
      } else if (this.selectedGeneralTypeChartBarData === "ggr") {
        this.chartBarData.dataSets[0].data = statesData.map((state) =>
          state.generalGGR.toFixed(2)
        );
        this.chartBarData.dataSets[0].label = "GGR";
        this.chartBarData.dataSets[0].backgroundColorVariant = [
          "GGR",
          "rgb(71, 126, 50)",
          "rgb(229,66,66)",
        ];

        // Popular dados do gráfico de Mapa dos jogadores
        this.labelTooltipChartMap = "GGR";
        this.stateColorChartMap = "rgb(71, 126, 50)";
        this.chartMapData = statesData.map((state) => [
          state.ufLabel,
          state.generalGGR,
        ]);
      } else if (this.selectedGeneralTypeChartBarData === "qtdPlayers") {
        this.chartBarData.dataSets[0].data = statesData.map(
          (state) => state.qtdPlayers
        );
        this.chartBarData.dataSets[0].label = this.$t("qtdPlayers");
        this.chartBarData.dataSets[0].backgroundColor = "#00BCD4";
        this.chartBarData.optionsGeneral.horizontalLabel = this.$t("qty");

        // Popular dados do gráfico de Mapa dos jogadores
        this.labelTooltipChartMap = this.$t("qtdPlayers");
        this.stateColorChartMap = "#00BCD4";
        this.chartMapData = statesData.map((state) => [
          state.ufLabel,
          state.qtdPlayers,
        ]);
      }

      // Atualizar a prop data do componente e forçar o watch para fazer
      // modificações no Data dentro do componente
      this.chartBarData = JSON.parse(JSON.stringify(this.chartBarData));
    },
    formatPlayersFiltered(allPlayersFormatted) {
      // Initialize result arrays
      let offensiveSportsPlayers = [];
      let noOffensiveSportsPlayers = [];
      let offensiveCasinoPlayers = [];
      let noOffensiveCasinoPlayers = [];

      // Iterar os jogadores do obj de players
      for (const key in allPlayersFormatted) {
        const player = allPlayersFormatted[key];
        const isOffensiveSportsPlayer = player.sport_ggr < 0;
        const isOffensiveCasinoPlayer = player.casino_ggr < 0;

        if (isOffensiveSportsPlayer) {
          offensiveSportsPlayers.push(player);
        } else {
          noOffensiveSportsPlayers.push(player);
        }

        if (isOffensiveCasinoPlayer) {
          offensiveCasinoPlayers.push(player);
        } else {
          noOffensiveCasinoPlayers.push(player);
        }
      }

      // Formatação dos jogadores para ofensivos e não ofensivos de
      // Sports e Casino
      // Sort each category by GGR and add percentage and ranking data
      offensiveSportsPlayers = offensiveSportsPlayers
        .sort((a, b) => a.sport_ggr - b.sport_ggr)
        .slice(0, 10)
        .map((player, index) => ({
          ...player,
          percentageGGR: this.getPercentage(player.sport_ggr, player.sport_bet),
          ranking: index + 1,
        }));

      noOffensiveSportsPlayers = noOffensiveSportsPlayers
        .sort((a, b) => b.sport_ggr - a.sport_ggr)
        .slice(0, 10)
        .map((player, index) => ({
          ...player,
          percentageGGR: this.getPercentage(player.sport_ggr, player.sport_bet),
          ranking: index + 1,
        }));

      offensiveCasinoPlayers = offensiveCasinoPlayers
        .sort((a, b) => a.casino_ggr - b.casino_ggr)
        .slice(0, 10)
        .map((player, index) => ({
          ...player,
          percentageGGR: this.getPercentage(player.casino_ggr, player.casino_bet),
          ranking: index + 1,
        }));

      noOffensiveCasinoPlayers = noOffensiveCasinoPlayers
        .sort((a, b) => b.casino_ggr - a.casino_ggr)
        .slice(0, 10)
        .map((player, index) => ({
          ...player,
          percentageGGR: this.getPercentage(player.casino_ggr, player.casino_bet),
          ranking: index + 1,
        }));

      this.offensiveSportsPlayers = offensiveSportsPlayers;
      this.noOffensiveSportsPlayers = noOffensiveSportsPlayers;
      this.offensiveCasinoPlayers = offensiveCasinoPlayers;
      this.noOffensiveCasinoPlayers = noOffensiveCasinoPlayers;

      // Popular opções no Filtro de Jogadores de Sports
      this.listPlayersSports.push(
        {
          user_name: this.$t("all"),
          user_id: "todos",
        },
        ...offensiveSportsPlayers,
        ...noOffensiveSportsPlayers
      );
      this.listPlayersCasino.push(
        {
          user_name: this.$t("all"),
          user_id: "todos",
        },
        ...offensiveCasinoPlayers,
        ...noOffensiveCasinoPlayers,
      );
    },
    getPercentage(partValue, allValue) {
      if (partValue == 0 || allValue == 0) {
        return "100.00";
      }
      return ((partValue * 100) / allValue).toFixed(2);
    },
    headersPlayers(isCasino) {
      return [
        { text: "#", value: "ranking" },
        { text: this.$t("userName"), value: "user_name", align: "start px-0" },
        { text: this.$t("bet"), value: isCasino ? "casino_bet" : "sport_bet" },
        {
          text: this.$t("prizeValue"),
          value: isCasino ? "casino_prize" : "sport_prize",
          align: "start px-0",
        },
        { text: "GGR", value: isCasino ? "casino_ggr" : "sport_ggr" },
        { text: "%", value: "percentageGGR" },
      ];
    },
    getColor(value, typeData) {
      if (typeData === "sport_bet") return "rgb(21, 101, 192)";
      if (typeData === "sport_prize") return "rgb(242, 167, 36)";
      if (typeData === "casino_bet") return "rgb(21, 101, 192)";
      if (typeData === "casino_prize") return "rgb(242, 167, 36)";
      if (+value == 0) return "";
      if (+value > 0) return "#4CAF50";
      if (+value < 0) return "#F44336";
    },
    getDataPlayerSelected(typeData) {
      let currentPlayer = {};

      if (typeData === "sports") {
        const findPlayer =
          this.noOffensiveSportsPlayers.find(
            (player) => player.user_id === this.playerSelectedSports
          ) ||
          this.offensiveSportsPlayers.find(
            (player) => player.user_id === this.playerSelectedSports
          );

        if (findPlayer) {
          currentPlayer = {
            qty_sport_bet: findPlayer.qty_sport_bet,
            qty_sport_prize: findPlayer.qty_sport_prize,
            ticket: {
              bet: this.getAverageValuePlayer(
                findPlayer.sport_bet,
                findPlayer.qty_sport_bet
              ),
              prize: this.getAverageValuePlayer(
                findPlayer.sport_prize,
                findPlayer.qty_sport_prize
              ),
              ggr: this.getAverageValuePlayer(
                findPlayer.sport_ggr,
                this.formatLengthDatesPlayers
              ),
            },
          };
        } else {
          currentPlayer = {
            qty_sport_bet: 0,
            qty_sport_prize: 0,
            ticket: {
              bet: 0,
              prize: 0,
              ggr: 0,
            },
          };
        }
      } else if (typeData === "casino") {
        const findPlayer =
          this.noOffensiveCasinoPlayers.find(
            (player) => player.user_id === this.playerSelectedCasino
          ) ||
          this.offensiveCasinoPlayers.find(
            (player) => player.user_id === this.playerSelectedCasino
          );

        if (findPlayer) {
          currentPlayer = {
            qty_casino_bet: findPlayer.qty_casino_bet,
            qty_casino_prize: findPlayer.qty_casino_prize,
            ticket: {
              bet: this.getAverageValuePlayer(
                findPlayer.casino_bet,
                findPlayer.qty_casino_bet
              ),
              prize: this.getAverageValuePlayer(
                findPlayer.casino_prize,
                findPlayer.qty_casino_prize
              ),
              ggr: this.getAverageValuePlayer(
                findPlayer.casino_ggr,
                this.formatLengthDatesPlayers
              ),
            },
          };
        } else {
          currentPlayer = {
            qty_casino_bet: 0,
            qty_casino_prize: 0,
            ticket: {
              bet: 0,
              prize: 0,
              ggr: 0,
            },
          };
        }
      }

      return currentPlayer;
    },
    getPortugueseMoney(value, onlyFormatValue) {
      if (onlyFormatValue) {
        return Number(value).toLocaleString("pt-BR");
      }

      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getAverageValuePlayer(value, qtdValue) {
      if (value == 0 && qtdValue == 0) return 0;
      return value / qtdValue;
    },
  },
};
</script>
<style scoped>
#div_googleChartMap {
  width: 100%;
}
</style>